let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("KNOvG")).then(() => parcelRequire('3GUgg'));